import type { PropsWithChildren } from "react";

import { cn } from "../../lib/cn";
import { Card } from "../ui/Card";

interface SectionContainerProps {
  title: string;
  eyebrow?: string;
  className?: string;
}

export function SectionContainer({ children, title, eyebrow, className }: PropsWithChildren<SectionContainerProps>) {
  return (
    <Card className={cn("space-y-5", className)}>
      <div className="space-y-2">
        {eyebrow ? <p className="text-xs uppercase tracking-[0.18em] text-ink-muted">{eyebrow}</p> : null}
        <h2 className="font-display text-2xl font-semibold text-white">{title}</h2>
      </div>
      {children}
    </Card>
  );
}
